const StateProduction = (state, production) => {
  const stateMultipliers = {
    Oregon: [0.029996459, 0.042693105, 0.076938641, 0.095351308, 0.130102686, 0.138297334, 0.147604836, 0.130659113, 0.092366837, 0.057666043, 0.032070413, 0.026253225],
    Nevada: [0.047474543, 0.056342302, 0.080956234, 0.102603008, 0.113763571, 0.114707667, 0.115887787, 0.107626947, 0.090532066, 0.072088475, 0.053105402, 0.044911997],
    Colorado: [0.046317242, 0.057704843, 0.084505962, 0.099497719, 0.111230398, 0.119819025, 0.121237683, 0.105824163, 0.087189908, 0.072849967, 0.050419846, 0.043403244],
    "New Mexico": [0.051883271, 0.061316593, 0.081404818, 0.102714625, 0.109569053, 0.11109603, 0.112012216, 0.106990159, 0.087376994, 0.072684086, 0.054394299, 0.048557855],
    "North Carolina": [0.04862771, 0.05909503, 0.085222121, 0.105291354, 0.110978324, 0.118766999, 0.116459243, 0.107805159, 0.084233083, 0.072158576, 0.046567213, 0.044795187],
    Utah: [0.042491291, 0.048195077, 0.079202236, 0.097615128, 0.122038051, 0.125712973, 0.131110516, 0.113999158, 0.090609807, 0.068024346, 0.043907668, 0.037093749],
    Texas: [0.047194767, 0.059621219, 0.081196597, 0.098170174, 0.102716861, 0.114175187, 0.113784619, 0.105735126, 0.091872274, 0.078812185, 0.056341361, 0.050398258],
    Virginia: [0.049078467, 0.058902557, 0.08484823, 0.103194928, 0.113564801, 0.116839498, 0.117301314, 0.111171754, 0.084386414, 0.069314413, 0.049036483, 0.04236114],
    default: [0.045382969, 0.055483841, 0.081784355, 0.10055478, 0.114245468, 0.119926839, 0.121924777, 0.111226447, 0.088368341, 0.072158576, 0.046567213, 0.044795187]
  };

  const multipliers = stateMultipliers[state] || stateMultipliers.default;

  const prodArray = multipliers.map((multiplier) => Math.round(production * multiplier));

  return prodArray;
};

export default StateProduction;

// avg productions per month per state. // THis could probably be scrapped because it is now coming from solargraf...

